import { postCall } from "../../networking";
import { posUrls, urls } from "../../networking/url";
import * as types from "../actions/types/pos.types";

export const getVirtualPosTerminals = (data) => async (dispatch) => {
    dispatch({ type: types.FETCH_VIRTUAL_POS_TERMINALS_STARTED });

    try {
        const response = await postCall(posUrls.getVirtualPosTerminals, { ...data });
        if (response?.data?.isSuccessful) {
            dispatch({
                type: types.FETCH_VIRTUAL_POS_TERMINALS_SUCCEEDED,
                payload: response?.data?.data,
            });
        } else {
            dispatch({ type: types.FETCH_VIRTUAL_POS_TERMINALS_FAILED, payload: [] });
        }
    } catch (err) {
        dispatch({
            type: types.FETCH_VIRTUAL_POS_TERMINALS_FAILED,
            message: "Error fetching virtual POS terminals",
        });
    }
};

export const getHardwarePosTerminals = (data) => async (dispatch) => {
    dispatch({ type: types.FETCH_HARDWARE_POS_TERMINALS_STARTED });

    try {
        const response = await postCall(posUrls.getHardwarePosTerminals, { ...data });
        if (response?.data?.isSuccessful) {
            dispatch({
                type: types.FETCH_HARDWARE_POS_TERMINALS_SUCCEEDED,
                payload: response?.data?.data,
            });
        } else {
            dispatch({ type: types.FETCH_HARDWARE_POS_TERMINALS_FAILED, payload: {} });
        }
    } catch (err) {
        dispatch({
            type: types.FETCH_HARDWARE_POS_TERMINALS_FAILED,
            message: "Error fetching physical POS terminals",
        });
        return { isError: true, message: "Error fetching physical POS Terminals" };
    }
};

export const getHardwareTerminalRequests = (data) => async (dispatch) => {
    dispatch({ type: types.FETCH_HARDWARE_POS_REQUESTS_STARTED });

    try {
        const response = await postCall(posUrls.getHardwareTerminalRequests, { ...data });
        if (response?.data?.isSuccessful) {
            dispatch({
                type: types.FETCH_HARDWARE_POS_REQUESTS_SUCCEEDED,
                payload: response?.data?.data,
            });
        } else {
            dispatch({ type: types.FETCH_HARDWARE_POS_TERMINALS_FAILED, payload: [] });
        }

        return response;
    } catch (err) {
        dispatch({
            type: types.FETCH_VIRTUAL_POS_TERMINALS_FAILED,
            message: "Error fetchin terminal requests",
        });
        return { isError: true, message: "Error fetching terminal requests" };
    }
};

export const activateHardwarePosTerminal = (data) => async () => {
    try {
        const response = await postCall(posUrls.activateHardwarePosTerminal, { ...data });
        if (response?.data?.isSuccessful) {
            return {
                data: response?.data?.data,
                isSuccessful: response?.data?.isSuccessful,
            };
        } else {
            return {
                data: null,
                isSuccessful: false,
                message: response?.data?.message || "",
            };
        }
    } catch (err) {
        return {
            data: null,
            isSuccessful: false,
            message: "",
        };
    }
};

export const fetchPosTerminalBalance = (payload) => async (dispatch) => {
    try {
        const response = await postCall(urls.getAccountBalance, payload);
        const time = new Date();

        if (response.data.isSuccessful) {
            return {
                ...response.data.customerAccountBalance,
                accountBalance: response.data.customerAccountBalance.withdrawableBalance,
                lastUpdated: time,
                isSuccessful: response.data.isSuccessful,
            };
        } else {
            return {
                isSuccessful: false,
                message: response.data.message,
            };
        }
    } catch (err) {
        return {
            isSuccessful: false,
            message: "",
        };
    }
};
export const purchaseHardwarePosTerminal = (data) => async (dispatch) => {
    try {
        const response = await postCall(posUrls.purchaseHardwarePosTerminal, data);
        if (response.data?.isSuccessful) {
            return {
                status: true,
                message: response?.data?.message,
                data: response?.data?.data
            };
        } else {
            return {
                status: false,
                message: response.data?.message,
                statusCode: response.data?.statusCode,
            };
        }
    } catch (error) {
        return {
            status: false,
            message: "Sorry, an error occurred. Please try again",
        };
    }
};

export const verifyTerminalPurchasePayment = (data) => async (dispatch) => {
    try {
        const response = await postCall(posUrls.verifyTerminalPurchasePayment, data);
        if (response.data?.isSuccessful) {
            return {
                status: true,
                message: response?.data?.message,
                data: response?.data?.data
            };
        } else {
            return {
                status: false,
                message: response.data?.message,
            };
        }
    } catch (error) {
        return {
            status: false,
            message: "Sorry, an error occurred. Please try again",
        };
    }
};


export const sweepTerminal = (payload) => async (dispatch) => {
    try {
        const response = await postCall(posUrls.sweepTerminal, payload);
        if (response?.data?.isSuccessful) {
            return {
                data: response?.data?.data,
                isSuccessful: response?.data?.isSuccessful,
            };
        } else {
            return {
                data: null,
                isSuccessful: false,
                message: response?.data?.message || "",
            };
        }
    } catch (err) {
        return {
            data: null,
            isSuccessful: false,
            message: "",
        };
    }
};

export const getSweepHistory = (payload) => async (dispatch) => {
    dispatch({ type: types.FETCH_SWEEP_HISTORY_STARTED });

    try {
        const response = await postCall(posUrls.sweepHistory, payload);
        if (response?.data?.isSuccessful) {
            dispatch({
                type: types.FETCH_SWEEP_HISTORY_SUCCEEDED,
                payload: response?.data?.data,
            });
        } else {
            dispatch({ type: types.FETCH_SWEEP_HISTORY_FAILED, payload: [] });
        }
    } catch (err) {
        dispatch({
            type: types.FETCH_SWEEP_HISTORY_FAILED,
            payload: "Error fetching physical POS terminals",
        });
        return { isError: true, msg: "Error fetching physical POS Terminals" };
    }
};

export const updateVirtualPOSNotification = (payload) => async (dispatch) => {
    try {
        const response = await postCall(posUrls.changeVirtualTerminalNotificationEmail, payload);
        if (response?.data?.isSuccessful) {
            return {
                data: response?.data?.data,
                isSuccessful: response?.data?.isSuccessful,
            };
        } else {
            return {
                data: null,
                isSuccessful: false,
                message: response?.data?.message || "",
            };
        }
    } catch (err) {
        return {
            data: null,
            isSuccessful: false,
            message: "",
        };
    }
};

// /api/v1/hardware/notification/update

export const updateHardwarePOSNotification = (payload) => async (dispatch) => {
    try {
        const response = await postCall(posUrls.updatePhysicalTerminalNotification, payload);
        if (response?.data?.isSuccessful) {
            return {
                data: response?.data?.data,
                isSuccessful: response?.data?.isSuccessful,
            };
        } else {
            return {
                data: null,
                isSuccessful: false,
                message: response?.data?.message || "",
            };
        }
    } catch (err) {
        return {
            data: null,
            isSuccessful: false,
            message: "",
        };
    }
};

export const restrictVirtualTerminal = (payload) => async (dispatch) => {
    try {
        const response = await postCall(posUrls.restrictVirtualTerminal, payload);
        if (response?.data?.isSuccessful) {
            return {
                data: response?.data?.data,
                isSuccessful: response?.data?.isSuccessful,
            };
        } else {
            return {
                data: null,
                isSuccessful: false,
                message: response?.data?.message || "",
            };
        }
    } catch (err) {
        return {
            data: null,
            isSuccessful: false,
            message: "",
        };
    }
};
export const createVirtualTerminal = (data) => async (dispatch) => {
    try {
        const response = await postCall(posUrls.createVirtualTerminal, data);
        if (response.data?.isSuccessful) {
            return {
                status: true,
                message: response.data?.message,
                data: response.data?.data,
            };
        } else {
            return {
                status: false,
                message: response.data?.message,
            };
        }
    } catch (error) {
        return {
            status: false,
            message: "Sorry, an error occurred. Please try again",
        };
    }
};

export const checkPOSOnboardingStatus = (payload) => async (dispatch) => {
    dispatch({ type: types.CHECK_POS_ONBOARDING_STATUS_STARTED });

    try {
        const response = await postCall(posUrls.checkTerminalOnboardingStatus, payload);
        if (response?.data?.isSuccessful) {
            dispatch({
                type: types.CHECK_POS_ONBOARDING_STATUS_SUCCEEDED,
                payload: response?.data?.data,
            });
        } else {
            dispatch({ type: types.CHECK_POS_ONBOARDING_STATUS_FAILED, payload: [] });
        }
    } catch (err) {
        dispatch({
            type: types.CHECK_POS_ONBOARDING_STATUS_FAILED,
            payload: "Error fetching physical POS terminals",
        });
        return { isError: true, msg: "Error fetching physical POS Terminals" };
    }
};
